const AssistantView = () => import("../presentation/views/AssistantView.vue");
/**
 * Assistant Module Routes and Navigation
 *
 * Owns the "/assistant" path which embeds the Orbital AI assistant.
 */
export const assistantRoutes = [
    {
        path: "/assistant",
        name: "Assistant",
        component: AssistantView,
        meta: { requiresAuth: true, titleKey: "assistant.title" },
    },
];
export const assistantNavigationItems = [];
